import { accordionTokens } from 'theme/components/accordion.tokens';
import { autoCompleteTokens } from 'theme/components/autocomplete.tokens';
import { avatarTokens } from 'theme/components/avatar.tokens';
import { badgeTokens } from 'theme/components/badge.tokens';
import { blockUITokens } from 'theme/components/blockui.tokens';
import { breadcrumbTokens } from 'theme/components/breadcrumb.tokens';
import { buttonTokens } from 'theme/components/button.tokens';
import { cardTokens } from 'theme/components/card.tokens';
import { carouselTokens } from 'theme/components/carousel.tokens';
import { checkboxTokens } from 'theme/components/checkbox.tokens';
import { chipTokens } from 'theme/components/chip.tokens';
import { colorPickerTokens } from 'theme/components/colorpicker.tokens';
import { confirmDialogTokens } from 'theme/components/confirmdialog.tokens';
import { confirmPopupTokens } from 'theme/components/confirmpopup.tokens';
import { contextMenuTokens } from 'theme/components/contextmenu.tokens';
import { dataTableTokens } from 'theme/components/datatable.tokens';
import { dataViewTokens } from 'theme/components/dataview.tokens';
import { datePickerTokens } from 'theme/components/datepicker.tokens';
import { dialogTokens } from 'theme/components/dialog.tokens';
import { dividerTokens } from 'theme/components/divider.tokens';
import { drawerTokens } from 'theme/components/drawer.tokens';
import { fieldsetTokens } from 'theme/components/fieldset.tokens';
import { fileUploadTokens } from 'theme/components/fileupload.tokens';
import { floatLabelTokens } from 'theme/components/floatlabel.tokens';
import { galleriaTokens } from 'theme/components/galleria.tokens';
import { iconFieldTokens } from 'theme/components/iconfield.tokens';
import { iftaLabelTokens } from 'theme/components/iftalabel.tokens';
import { imageTokens } from 'theme/components/image.tokens';
import { inplaceTokens } from 'theme/components/inplace.tokens';
import { inputGroupTokens } from 'theme/components/inputgroup.tokens';
import { inputNumberTokens } from 'theme/components/inputnumber.tokens';
import { inputOtpTokens } from 'theme/components/inputotp.tokens';
import { inputTextTokens } from 'theme/components/inputtext.tokens';
import { knobTokens } from 'theme/components/knob.tokens';
import { listboxTokens } from 'theme/components/listbox.tokens';
import { megaMenuTokens } from 'theme/components/megamenu.tokens';
import { menuTokens } from 'theme/components/menu.tokens';
import { menubarTokens } from 'theme/components/menubar.tokens';
import { messageTokens } from 'theme/components/message.tokens';
import { meterGroupTokens } from 'theme/components/metergroup.tokens';
import { multiSelectTokens } from 'theme/components/multiselect.tokens';
import { orderListTokens } from 'theme/components/orderlist.tokens';
import { organizationChartTokens } from 'theme/components/organizationchart.tokens';
import { paginatorTokens } from 'theme/components/paginator.tokens';
import { panelTokens } from 'theme/components/panel.tokens';
import { panelMenuTokens } from 'theme/components/panelmenu.tokens';
import { passwordTokens } from 'theme/components/password.tokens';
import { pickListTokens } from 'theme/components/picklist.tokens';
import { popoverTokens } from 'theme/components/popover.tokens';
import { progressBarTokens } from 'theme/components/progressbar.tokens';
import { progressSpinnerTokens } from 'theme/components/progressspinner.tokens';
import { radioButtonTokens } from 'theme/components/radiobutton.tokens';
import { ratingTokens } from 'theme/components/rating.tokens';
import { rippleTokens } from 'theme/components/ripple.tokens';
import { scrollPanelTokens } from 'theme/components/scrollpanel.tokens';
import { selectTokens } from 'theme/components/select.tokens';
import { selectButtonTokens } from 'theme/components/selectbutton.tokens';
import { skeletonTokens } from 'theme/components/skeleton.tokens';
import { sliderTokens } from 'theme/components/slider.tokens';
import { speedDialTokens } from 'theme/components/speeddial.tokens';
import { splitButtonTokens } from 'theme/components/splitbutton.tokens';
import { splitterTokens } from 'theme/components/splitter.tokens';
import { stepperTokens } from 'theme/components/stepper.tokens';
import { tabsTokens } from 'theme/components/tabs.tokens';
import { tabViewTokens } from 'theme/components/tabview.tokens';
import { tagTokens } from 'theme/components/tag.tokens';
import { terminalTokens } from 'theme/components/terminal.tokens';
import { textareaTokens } from 'theme/components/textarea.tokens';
import { tieredMenuTokens } from 'theme/components/tieredmenu.tokens';
import { timelineTokens } from 'theme/components/timeline.tokens';
import { toastTokens } from 'theme/components/toast.tokens';
import { toggleButtonTokens } from 'theme/components/togglebutton.tokens';
import { toggleSwitchTokens } from 'theme/components/toggleswitch.tokens';
import { tooltipTokens } from 'theme/components/tooltip.tokens';
import { treeTokens } from 'theme/components/tree.tokens';
import { treeSelectTokens } from 'theme/components/treeselect.tokens';
import { treeTableTokens } from 'theme/components/treetable.tokens';
import { virtualScrollerTokens } from 'theme/components/virtualscroller.tokens';

import type { ComponentsDesignTokens } from '@primeuix/themes/types';

export const componentsTokens: ComponentsDesignTokens = {
  accordion: accordionTokens,
  autocomplete: autoCompleteTokens,
  avatar: avatarTokens,
  badge: badgeTokens,
  blockui: blockUITokens,
  breadcrumb: breadcrumbTokens,
  button: buttonTokens,
  card: cardTokens,
  carousel: carouselTokens,
  checkbox: checkboxTokens,
  chip: chipTokens,
  colorpicker: colorPickerTokens,
  confirmdialog: confirmDialogTokens,
  confirmpopup: confirmPopupTokens,
  contextmenu: contextMenuTokens,
  datatable: dataTableTokens,
  dataview: dataViewTokens,
  datepicker: datePickerTokens,
  dialog: dialogTokens,
  divider: dividerTokens,
  drawer: drawerTokens,
  fieldset: fieldsetTokens,
  fileupload: fileUploadTokens,
  floatlabel: floatLabelTokens,
  galleria: galleriaTokens,
  iconfield: iconFieldTokens,
  iftalabel: iftaLabelTokens,
  image: imageTokens,
  inplace: inplaceTokens,
  inputgroup: inputGroupTokens,
  inputnumber: inputNumberTokens,
  inputotp: inputOtpTokens,
  inputtext: inputTextTokens,
  knob: knobTokens,
  listbox: listboxTokens,
  megamenu: megaMenuTokens,
  menu: menuTokens,
  menubar: menubarTokens,
  message: messageTokens,
  metergroup: meterGroupTokens,
  multiselect: multiSelectTokens,
  orderlist: orderListTokens,
  organizationchart: organizationChartTokens,
  paginator: paginatorTokens,
  panel: panelTokens,
  panelmenu: panelMenuTokens,
  password: passwordTokens,
  picklist: pickListTokens,
  popover: popoverTokens,
  progressbar: progressBarTokens,
  progressspinner: progressSpinnerTokens,
  radiobutton: radioButtonTokens,
  rating: ratingTokens,
  ripple: rippleTokens,
  scrollpanel: scrollPanelTokens,
  select: selectTokens,
  selectbutton: selectButtonTokens,
  skeleton: skeletonTokens,
  slider: sliderTokens,
  speeddial: speedDialTokens,
  splitbutton: splitButtonTokens,
  splitter: splitterTokens,
  stepper: stepperTokens,
  tabs: tabsTokens,
  tabview: tabViewTokens,
  tag: tagTokens,
  terminal: terminalTokens,
  textarea: textareaTokens,
  tieredmenu: tieredMenuTokens,
  timeline: timelineTokens,
  toast: toastTokens,
  togglebutton: toggleButtonTokens,
  toggleswitch: toggleSwitchTokens,
  tooltip: tooltipTokens,
  tree: treeTokens,
  treeselect: treeSelectTokens,
  treetable: treeTableTokens,
  virtualscroller: virtualScrollerTokens,
};
